import { initContract } from "@ts-rest/core";
import { bankAccountContract } from "./bank-account-contract";
import { catalogContract } from "./catalog-contract";
import { couponContract } from "./coupon-contract";
import { featureMappingContract } from "./feature-mapping-contract";
import { franchiseBillingAccountContract } from "./franchise-billing-account-contract";
import { billingHealthContract } from "./health-contract";
import { invoiceContract } from "./invoice-contract";
import { planMetadataContract } from "./plan-metadata-contract";
import { subscriptionContract } from "./subscription-contract";

const c = initContract();

export const billingContract = c.router({
  catalog: catalogContract,
  accounts: franchiseBillingAccountContract,
  subscriptions: subscriptionContract,
  invoices: invoiceContract,
  featureMappings: featureMappingContract,
  metadata: planMetadataContract,
  bankAccounts: bankAccountContract,
  coupons: couponContract,
  health: billingHealthContract,
});

export type BillingContract = typeof billingContract;

export * from "./bank-account-contract";
export * from "./catalog-contract";
export * from "./coupon-contract";
export * from "./feature-keys";
export * from "./feature-mapping-contract";
export * from "./franchise-billing-account-contract";
export * from "./health-contract";
export * from "./invoice-contract";
export * from "./plan-metadata-contract";
export * from "./subscription-contract";
